import { LoadingBlock } from "../components/LoadingBlock";
import { cn } from "../lib/utils";
import React from "react";
/**
 * A text-line placeholder for a table cell. Defaults to 96px wide and 12px high,
 * capped at the available width. Compose multiple lines for names and descriptions;
 * keep their widths and spacing next to the table's loaded cell renderer.
 */
export function TextCellSkeleton({ className }) {
    return React.createElement(LoadingBlock, { className: cn("h-3 w-24 max-w-full", className) });
}
//# sourceMappingURL=TextCellSkeleton.js.map